import TimeAgo from 'react-timeago'
import List from 'components/List'
import InternalLink from 'components/InternalLink'
import styled, { css } from 'styled-components'
import moment from 'moment'

const Item = styled.li`
  &.feedback {
    margin-left: 10px;
  }

  ${(props) =>
    !props.completed &&
    css`
      &.tutorial {
        text-decoration: underline;
      }
    `}
`

const Action = ({ action, handleLinkClick }) => {
  const formatted = moment(action.timestamp).format('lll')
  return (
    <Item className={action.type} completed={action.completed}>
      <span>
        <TimeAgo date={action.timestamp} title={formatted} />:{' '}
      </span>
      <span>{action.action} </span>
      <span>
        {action.target && (
          <b>
            {action.linkTo && (
              <InternalLink onClick={handleLinkClick} to={action.linkTo}>
                {action.target}
              </InternalLink>
            )}
            {!action.linkTo && <>{action.target}</>}
          </b>
        )}
        {action.target === undefined && <>unknown</>}
      </span>
    </Item>
  )
}

const Actions = ({ actions, handleLinkClick }) => {
  if (actions.length === 0) {
    return null
  }
  const actionList = actions.map((action, index) => (
    <Action key={index} action={action} handleLinkClick={handleLinkClick} />
  ))

  return (
    <div>
      <hr />
      <List>{actionList}</List>
    </div>
  )
}

export default Actions
